import type { OverviewContractValueRepository } from '../../application/OverviewContractValueRepository'

/** Démonstration sans base seulement (jamais en repli d'une vraie) : somme égale à la fixture des indicateurs. */
export function createFixtureOverviewContractValueRepository(): OverviewContractValueRepository {
  return {
    load(season) {
      return Promise.resolve({
        season,
        computedAt: new Date().toISOString(),
        byType: [
          {
            contractType: 'RESIDENTIAL',
            signedCount: 262,
            signedValueCents: 11_034_000,
            awaitingSignatureCount: 47,
            awaitingSignatureValueCents: 1_574_000,
          },
          {
            contractType: 'COMMERCIAL',
            signedCount: 19,
            signedValueCents: 2_600_000,
            awaitingSignatureCount: 4,
            awaitingSignatureValueCents: 400_000,
          },
          {
            contractType: 'MULTIFAMILY',
            signedCount: 9,
            signedValueCents: 1_600_000,
            awaitingSignatureCount: 2,
            awaitingSignatureValueCents: 200_000,
          },
        ],
      })
    },
  }
}
